import React, { useEffect, useState, useMemo } from 'react';
import { jt, t } from 'ttag';

import './style.less';

function UserGeneratedContent({ productID }) {
  const [showHeader, toggleHeader] = useState(false);

  useEffect(() => {
    /*
     * Reset the Header everytime the Product ID changes.
     * */
    toggleHeader(false);

    let subscribe;

    if (window.crl8 && window.crl8.ready) {
      window.crl8.ready(() => {
        window.crl8.destroyAllExperiences().then(() => {
          window.crl8.createExperience('product').then((experience) => {
            /*
             * In order to have a Dynamic Header, which only shows when pictures have been loaded, we
             *  subscribe to Redux Store changes. This is the best way to do it at the moment.
             * */
            const { store } = experience;
            subscribe = store.subscribe(() => {
              if (!showHeader && store.getState().content.main.length > 0) {
                toggleHeader(true);
              }
            });
          });
        });
      });
    }
    return subscribe ? subscribe() : undefined;
  }, [productID]);

  /**
   * @type {node} The Hashtag to use for Curalate / the Visual Galleries.
   */
  const igLink = useMemo(() => {
    if (window.socialLinks && window.socialLinks.instagram_hashtag) {
      return <b key={productID}>{window.socialLinks.instagram_hashtag}</b>;
    }
    return <b key={productID}>#unisportlife</b>;
  }, []);

  return (
    <div className="mb-8">
      {showHeader && (
        <div className="mb-4 flex flex-col items-center">
          <h2 className="text-2xl font-bold md:text-[32px]">{t`Show how you wear it`}</h2>
          <p>{jt`Share a photo of your favorite design and get the chance to become part of our Unisport Exhibition. Remember to tag your photo with ${igLink}`}</p>
        </div>
      )}
      <div
        data-crl8-container-id="product"
        data-crl8-auto-init="false"
        data-crl8-filter={`productId:'${productID}'`}
        data-crl8-locale={window.config.iso_language_code}
      />
    </div>
  );
}

export default UserGeneratedContent;
